<template>
 <el-table
    border
    :data="tableData"
    stripe
    :header-cell-style="{background:'#eef1f6',color:'#606266'}"
    style="width: 100%">
    <el-table-column 
    :label="$t('mangeroutsider.id', { msg: ' mangeroutsider.id' })" 
    prop="id"
    width="50">
    </el-table-column>
    <el-table-column 
    :label="$t('mangeroutsider.username', { msg: ' mangeroutsider.username' })"
    prop="username"
    width="150">
    </el-table-column>
    <!-- <el-table-column 
    :label="$t('mangeroutsider.password', { msg: ' mangeroutsider.password' })"
    prop="password">
    </el-table-column> -->
    <el-table-column 
    :label="$t('mangeroutsider.name', { msg: ' mangeroutsider.name' })"
    prop="name">
    </el-table-column>
    <el-table-column 
    :label="$t('mangeroutsider.email', { msg: ' mangeroutsider.email' })" 
    prop="email" width="220">
    </el-table-column>
    <el-table-column 
    :label="$t('mangeroutsider.companyName', { msg: ' mangeroutsider.companyName' })"
    prop="companyName">
    </el-table-column>
    <el-table-column
      prop="roleName"
      :label="$t('mangeroutsider.role', { msg: ' mangeroutsider.role' })"
      width="180">
      <template #default="scope">
                <span>
                  <span v-if="scope.row.roleId == 4" style="font-family:bold; color: rgb(50, 107, 192);">{{ $t('mangeroutsider.outsider', { msg: 'mangeroutsider.outsider' }) }}</span>
                  <span v-else-if="scope.row.roleId == 5" style="font-family:bold; color: hsl(180, 82%, 39%);">{{ $t('mangeroutsider.expert', { msg: 'mangeroutsider.expert' }) }}</span>
                  <span v-else-if="scope.row.roleId == 3" style="font-family:bold; color: hsl(180, 82%, 39%);">{{ $t('mangeroutsider.customer', { msg: 'mangeroutsider.customer' }) }}</span>
                </span>
            </template>
    </el-table-column>
    <el-table-column
      prop="isPass"
      :label="$t('mangeroutsider.ispass', { msg: ' mangeroutsider.ispass' })"
      width="150">
      <template #default="scope">
                <span>
                  <span v-if="scope.row.isPass == 1" style="font-family:bold; color: rgb(18, 179, 58);">{{ $t('mangeroutsider.passto', { msg: 'mangeroutsider.passto' }) }}</span>
                  <span v-else-if="scope.row.isPass == 0" style="font-family:bold; color: rgb(154, 218, 51);">{{ $t('mangeroutsider.passun', { msg: 'mangeroutsider.passun' }) }}</span>
                  <span v-else-if="scope.row.isPass == 2" style="font-family:bold; color: rgb(179, 18, 31);">{{ $t('mangeroutsider.passno', { msg: 'mangeroutsider.passno' }) }}</span>
                </span>
            </template>
    </el-table-column>
    <el-table-column 
    :label="$t('mangeroutsider.createTime', { msg: ' mangeroutsider.createTime' })" 
    prop="createTime" width="200">
    </el-table-column>
    <el-table-column :label="$t('kbReview.table.opr', { msg: 'kbReview.table.opr' })" width="230">
            <template #default="scope">
                <el-button
                    size="mini"
                    type="primary" 
                    icon="el-icon-edit"
                    @click="handleEdit(scope.$index, scope.row)">{{ $t('kbReview.approve', { msg: 'kbReview.approve' }) }}</el-button>
                <el-button
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row.id)">{{ $t('kbReview.delete', { msg: 'kbReview.delete' }) }}</el-button>
            </template>
     </el-table-column>
  </el-table>
<!-- 分页组件 -->
  <el-pagination
                background
                layout="sizes,prev, pager, next,jumper,->,total"
                :page-size="this.pageParam.pageSize"
                :current-page="this.pageParam.pageNum"
                :page-sizes="pageSizes"
                :total="total"
                :hide-on-single-page="true"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
            >
 </el-pagination>

 <el-dialog :title="$t('mangeroutsider.auditusers', { msg: 'mangeroutsider.auditusers' })" v-model="dialogFormVisible" :before-close="typeDialogClose" width="30%">
  <el-form :model="updateForm" ref="updateForm" :rules="passrules" label-width="85px">
    <el-form-item :label="$t('mangeroutsider.applyinstruction', { msg: ' mangeroutsider.applyinstruction' })">
    <el-input type="textarea" v-model="updateForm.applyTips" disabled></el-input>
    </el-form-item>
    <el-form-item :label="$t('mangeroutsider.attachment', { msg: ' mangeroutsider.attachment' })" v-if="outsiderFileTable != undefined && outsiderFileTable != null && outsiderFileTable.length > 0 ">
      <el-table :data="outsiderFileTable" >
              <el-table-column :label="$t('mangeroutsider.filename', { msg: ' mangeroutsider.filename' })" prop="fileName"></el-table-column>
              <el-table-column :label="$t('mangeroutsider.filetype', { msg: ' mangeroutsider.filetype' })" prop="fileType"></el-table-column>
              <el-table-column :label="$t('issue.table.opr', { msg: 'issue.table.opr' })">
              <template #default="scope">
              <el-button
                  size="mini"
                  type="success"
                  @click="handleLoadTrace(scope.$index, scope.row.fileUrl)">{{ $t('issue.table.download', { msg: 'issue.table.download' }) }}</el-button>
            </template>
              </el-table-column>
      </el-table> 
    </el-form-item>
    <el-form-item :label="$t('mangeroutsider.name', { msg: ' mangeroutsider.name' })" >
      <el-input v-model="updateForm.name" autocomplete="off"></el-input>
    </el-form-item>
    <!-- <el-form-item :label="$t('mangeroutsider.password', { msg: ' mangeroutsider.password' })" >
      <el-input v-model="updateForm.password" autocomplete="off"></el-input>
    </el-form-item> -->
    <el-form-item :label="$t('mangeroutsider.userRole', { msg: ' mangeroutsider.userRole' })" >
      <el-select style="width: 100%" v-model="updateForm.roleId" :placeholder="$t('mangeroutsider.inputuserrole', { msg: ' mangeroutsider.inputuserrole' })">
            <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.label"
            :value="item.value">
            </el-option>
      </el-select>
    </el-form-item>
    <el-form-item :label="$t('mangeroutsider.companyName', { msg: ' mangeroutsider.companyName' })" prop="companyName">
       <el-select
                style="width: 100%"
                v-model="updateForm.companyName"     
                filterable
                allow-create
                default-first-option
                :placeholder="$t('applyoutsider.tipscompanyname', { msg: 'applyoutsider.tipscompanyname' })">
                <!-- <el-option key="0" :label="updateForm.companyName" :value="updateForm.companyName" /> -->
                <el-option
                v-for="item in companyData"
                :key="item.companyID"
                :label="item.companyname"
                :value="item.companyname">
                </el-option>
            </el-select>
    </el-form-item> 
    <el-form-item :label="$t('mangeroutsider.passstatus', { msg: ' mangeroutsider.passstatus' })" >
        <el-radio-group v-model="updateForm.isPass">
        <el-radio :label="2">{{ $t('mangeroutsider.passno', { msg: 'mangeroutsider.passno' }) }}</el-radio>
        <el-radio :label="1">{{ $t('mangeroutsider.passto', { msg: 'mangeroutsider.passto' }) }}</el-radio>
        </el-radio-group>
    </el-form-item>
  </el-form>
  <div >
    <el-button @click="dialogFormVisible = false">{{ $t('mangeroutsider.calcel', { msg: 'mangeroutsider.calcel' }) }}</el-button>
    <el-button type="primary" @click="editKb('updateForm')">{{ $t('mangeroutsider.sure', { msg: 'mangeroutsider.sure' }) }}</el-button>
  </div>
</el-dialog>

</template>

<script>
 import { baseUrl_New } from '../../axios/urlconfig';
 import axios from 'axios';
import { deleteRequest, getRequest, postRequest } from '../../axios/axios';

export default {
    data() {
      return {
        tableData: [],
        pageParam: {//分页参数
          pageNum: 1,//当前页
          pageSize: 10,//每页条目数据
        },
        total: 0,//总条目数
        pageSizes: [10, 20, 30, 40],//每页显示条目数列表
        dialogFormVisible:false,
        updateForm:{
            id:'',
            name:'',
            username:'',
            userId:'',
            passwordPlainText: '',
            password:'',
            email:'',
            roleId:'',
            companyId:'',
            companyName: '',
            applyTips:'',
            isPass:'',
        },
        options: [
        {
          id:1,
          value: 3,
          label: '客户'
        }, 
        {
          id:2,
          value: 4,
          label: '普通管理员'
        }, 
        {
          id:3,
          value: 5,
          label: '专家'
        }
      ],
        companyData:[],
        outsidertableid:'',
        outsiderFileTable:[],
        passrules: {
          companyName: [
            { required: true, message: this.$t('applyoutsider.tipscompanyname', { msg: 'applyoutsider.tipscompanyname' }), trigger: 'click' }
          ],
          isPass: [
            { required: true, message: '请选择审核状态', trigger: 'change' }
          ],
        },


      }
    },

    created(){
        this.getAllList();
        this.getcompanylist();
      },

    methods: {
      handleEdit(index, row) {
        this.dialogFormVisible=true;
        this.updateForm = JSON.parse(JSON.stringify(row));
        //调用查询文件的方法
        this.outsidertableid=this.updateForm.id;
        this.getResumeTable();
      },
      typeDialogClose(){  //关闭审核对话框
       this. dialogFormVisible = false;
       },
    
      getAllList(){
        getRequest(baseUrl_New+'/out/page/'+ this.pageParam.pageNum + '/' + this.pageParam.pageSize).then(response=>{
          //获得服务器端回传的map对象
          console.log(response);
          let resultMap = response.data;
            //从集合中获取用户列表及总条目数
            //this.tableData = resultMap.list;
            this.tableData =response.list;
            //this.total = resultMap.total;
            this.total =response.total;
        })
       },
       handleSizeChange(val) {
        // console.log(`每页 ${val} 条`);
        this.pageParam.pageSize = val;
        this.getAllList();
        },
        handleCurrentChange(val) {
        // console.log(`当前页: ${val}`);
        this.pageParam.pageNum = val;
        this.getAllList();
        },
        handleDelete(index, id){
        this.$confirm( this.$t('agent.deleteDF', { msg: 'agent.deleteDF' }), this.$t('issue.tips', { msg: 'issue.tips' }),{
            confirmButtonText: this.$t('addType.confirm', { msg: 'addType.comfirm' }),
            cancelButtonText: this.$t('addType.cancel', { msg: 'addType.cancel' }),
            cancelButtonClass: 'btn-custom-cancel',
            type: 'warning'
        }).then(() => {
            deleteRequest(baseUrl_New + `/out/del/${id}`)
            .then(response=>{
            // console.log(response);
            this.getAllList();  
            this.$message.success(this.$t('issue.deleteS', { msg: 'issue.deleteS' }))
                    
            }).catch(err => {
              this.message.error(this.$t('issue.deleteF', { msg: 'issue.deleteF' }));
        })
        })
        },
        editKb(formName){ //审核用户
          this.$refs[formName].validate((valid) => {
          if (valid) {
            var that = this
        postRequest(baseUrl_New + '/out/pass',{
          id:this.updateForm.id,
          name:this.updateForm.name,
          username:this.updateForm.username,
          password:this.updateForm.password,
          passwordPlainText: this.updateForm.passwordPlainText,
          email:this.updateForm.email,
          userId:this.updateForm.userId,
          roleId:this.updateForm.roleId,
          companyName:this.updateForm.companyName,
          companyId:this.updateForm.companyId,
          isPass:this.updateForm.isPass
        }).then(resp=>{
          this.typeDialogClose();
          this.getAllList();
          //清空form输入框
          this.updateForm={};
          this.$message.success(this.$t('kbReview.reviewS', { msg: 'kbReview.reviewS' }));
        }).catch(err => {
          this.$message.error(this.$t('issue.error', { msg: 'issue.error' }))
        })
          } else {
            
            return false;
          }
        });
            
        },
        getcompanylist(){
        getRequest(baseUrl_New+'/company/getlist').then(response=>{
        
            this.companyData = response;
        })
      },
      getResumeTable(){
        getRequest(baseUrl_New+'/out/list/'+this.outsidertableid).then(response=>{  
        this.outsiderFileTable = response.data.list;
    })
      },
       //文件下载
     handleLoadTrace(index, fileUrl) {
      getRequest(baseUrl_New + '/oss/file/downloadFile?fileUrl=' + fileUrl, {
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/octet-stream'
      }
    }).then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      const filename = fileUrl.substring(fileUrl.lastIndexOf('/') + 1);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    }).catch(
      (error)=>{
        this.$message.error(this.$t('issue.issueInfoFile', { msg: 'issue.issueInfoFile' }))
      }
    );
    },


    }
  }
</script>

<style>
.btn-custom-cancel {
  float: right;
  margin-left: 10px;
}
</style>